import React, { useContext, useEffect, useState } from "react";
import { Form, Spinner } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { Context } from "../../../index";
import { observer } from "mobx-react-lite";
import { createBookType, fetchTypes } from "../../../http/bookAPI"; // ✅ API-запросы

const CreateBookType = observer(({ show, handleClose }) => {
    const { book } = useContext(Context);

    const [type, setType] = useState("");
    const [typeName, setTypeName] = useState("");
    const [typeTodo, setTypeTodo] = useState("");
    const [priceAddition, setPriceAddition] = useState("");
    const [priceShift, setPriceShift] = useState("");
    const [promotionDiscount, setPromotionDiscount] = useState("");
    const [promotionBonus, setPromotionBonus] = useState("");

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    useEffect(() => {
        fetchTypes().then((data) => book.setTypes(data));
    }, []);

    const addBookType = async () => {
        setLoading(true);
        setError("");
        try {
            await createBookType({
                type,
                type_name: typeName,

            });

            const updatedBookTypes = await fetchTypes(); // ✅ Обновляем список типов книг
            book.setTypes(updatedBookTypes);
            book.setSelectedBookType({}); // ✅ Сбрасываем выбранный тип
            setType("");
            setTypeName("");
            setTypeTodo("");
            setPriceAddition("");
            setPriceShift("");
            setPromotionDiscount("");
            setPromotionBonus("");
            handleClose(); // ✅ Закрываем модальное окно
        } catch (e) {
            const errorMessage = e.response?.data?.message || "An error occurred while adding the book type.";
            setError(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal show={show} onHide={() => { setError(""); handleClose(); }} centered>
            <div className="modal-content">
                <div className="modal-header">
                    <h1 className="modal-title fs-5">Add a New Book Type:</h1>
                    <button
                        type="button"
                        className="btn-close"
                        onClick={() => {
                            setError("");
                            handleClose();
                        }}
                    ></button>
                </div>

                <div className="modal-body">
                    {error && <div className="alert alert-danger">{error}</div>}
                    <Form>
                        <Form.Group className="mb-2">
                            <Form.Label>Book Type:</Form.Label>
                            <Form.Control
                                value={type}
                                onChange={(e) => setType(e.target.value)}
                                placeholder="Enter book type"
                                disabled={loading}
                            />
                        </Form.Group>

                        <Form.Group className="mb-2">
                            <Form.Label>Book Type Name:</Form.Label>
                            <Form.Control
                                value={typeName}
                                onChange={(e) => setTypeName(e.target.value)}
                                placeholder="Enter book type name"
                                disabled={loading}
                            />
                        </Form.Group>









                    </Form>
                </div>

                <div className="modal-footer">
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => {
                            setError("");
                            handleClose();
                        }}
                        disabled={loading}
                    >
                        Close
                    </button>
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={addBookType}
                        disabled={loading || !type.trim() || !typeName.trim()}
                    >
                        {loading ? <Spinner as="span" animation="border" size="sm" /> : "Add in DB"}
                    </button>
                </div>
            </div>
        </Modal>
    );
});

export default CreateBookType;
